import { apiURL } from "../../config";
import { Button } from "../Button";
import { getUserProfile } from "../../api/user/profile";
import { QueryLoader } from "../Loader";
import { StyledProfileDetails } from "../../styles/StyledProfileDetails";
import { useQuery } from "react-query";
import EditIcon from "../../assets/img/icons/edit.svg";
import ProfileDetailsData from "./ProfileDetailsData";
import ProfileDetailsImage from "./ProfileDetailsImage";
import PropTypes from "prop-types";
import StatusInfo from "../StatusInfo/StatusInfo";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

export default function ProfileDetails({ setIsEditMode }) {
	const { axiosPrivate } = useAxiosPrivate();
	const { isLoading, isError, error, data } = useQuery("userProfile", () => getUserProfile(axiosPrivate));

	if (isLoading) {
		return <QueryLoader />;
	}
	if (isError) {
		return <div>{error}</div>;
	}

	const { avatar, status, firstName, lastName } = data;

	return (
		<StyledProfileDetails>
			<header>
				<ProfileDetailsImage avatar={avatar?.url ? apiURL.replace("/api", "") + avatar?.url : undefined}></ProfileDetailsImage>
				<Button onClick={() => setIsEditMode(true)} bg={false} small={true} icon={EditIcon}>
					Edit profile
				</Button>
				<div>
					<h1>{`${firstName} ${lastName}`}</h1>
					{status ? <StatusInfo>{status}</StatusInfo> : ""}
				</div>
			</header>
			<ProfileDetailsData data={data} />
		</StyledProfileDetails>
	);
}

ProfileDetails.propTypes = {
	setIsEditMode: PropTypes.func,
};
